import { DocumentTemplatesArchiveFileData } from "@interfaces/company/document-templates";
import { documentTemplateService } from "@services/document-templates-service";
import { useMutation, useQueryClient } from "react-query";
import { documentTemplatesQueryKeys } from "./queryKeys";

export const useArchiveDocumentTemplateFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DocumentTemplatesArchiveFileData) =>
      documentTemplateService.archiveFile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
